import { toast } from 'react-toastify';

export enum ToastMessageTypes {
    CHAPTER_UNLOCKED_BY_WAITED_COUPON = 0,
    CHAPTER_UNLOCKED_BY_KARMA = 1,
    CHAPTER_AUTO_UNLOCK_ERROR = 2,
    CHAPTER_UNLOCKED_BY_VOUCHER = 3,
}

export const toastMessageFactory = {
    [ToastMessageTypes.CHAPTER_UNLOCKED_BY_KARMA]: ({ karmaPrice }: { karmaPrice: number | string }) => {
        toast(`You opened a new chapter using ${karmaPrice} Karma.`);
    },
    [ToastMessageTypes.CHAPTER_UNLOCKED_BY_WAITED_COUPON]: () => {
        toast(`You opened a new chapter by waiting the required time.`);
    },
    [ToastMessageTypes.CHAPTER_AUTO_UNLOCK_ERROR]: () => {
        toast(`Sorry, your Auto-Unlock has been reset`);
    },
    [ToastMessageTypes.CHAPTER_UNLOCKED_BY_VOUCHER]: ({ voucherAmount }: { voucherAmount: number }) => {
        toast(`You opened a new chapter using ${voucherAmount} cultivation key${voucherAmount > 1 ? 's' : ''}.`);
    },
} as const;
